import { FC } from 'react';
import { useRouter } from 'next/router';
import NavCommon from '../../components/NavCommon';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { locale } = useRouter();
    const { t } = useLang('dp3.teaser.Nav');
    const listCommon: any = [
        {
            title: t('title1'),
            href: 'dp3-teaser-B',
        },
        {
            title: t('title2'),
            href: 'dp3-teaser-C',
        },
        {
            title: t('title3'),
            href: 'dp3-teaser-E',
        },
        {
            title: t('title4'),
            href: 'dp3-teaser-K',
        },
    ];
    const listJP: any = [
        {
            title: t('title1'),
            href: 'dp3-teaser-C',
        },
        {
            title: t('title2'),
            href: 'dp3-teaser-E',
        },
        {
            title: t('title3'),
            href: 'dp3-SubscribeA',
        },
        {
            title: t('title4'),
            href: 'dp3-teaser-J',
        },
    ];
    let listA = [];
    if (locale === 'jp') {
        listA = listJP;
    } else {
        listA = listCommon;
    }

    return <NavCommon list={listA} />;
};

export default TheComp;
